import { jsx as _jsx } from "react/jsx-runtime";
import { AccountLookUpViewModel } from '../../ViewModels/AccountLookUpViewModel';
import { LookUp } from './LookUp';
import LinkForAccount1 from '@styles/webdesktop/Icons/linkForAccount1.svg';
export class AccountLookUp extends LookUp {
    constructor(props) {
        super(props, AccountLookUpViewModel);
        this.cssClass = 'js-tercera-lookup account-lookup';
        this.btnClass = 'js-lookup-showAcc';
    }
}
AccountLookUp.defaultProps = Object.assign(Object.assign({}, LookUp.defaultProps), { showMAM: false, btnImage: _jsx(LinkForAccount1, {}) });
